function NewsletterFactory($resource, Config) {
    'ngInject';

    return $resource(
        `${Config.HAUSSMANN_HOST}/_ah/api/lumsites/v1/newsletter/:methodKey`,
        {},
        {
            delete: {
                isArray: false,
                method: 'DELETE',
                params: {
                    methodKey: 'delete',
                },
            },

            deleteMulti: {
                isArray: false,
                method: 'DELETE',
                params: {
                    methodKey: 'deleteMulti',
                },
            },

            get: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'get',
                },
            },

            list: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'list',
                },
            },

            save: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },

            send: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'send',
                },
            },
        },
    );
}

/////////////////////////////

angular.module('Factories').factory('NewsletterFactory', NewsletterFactory);

/////////////////////////////

export { NewsletterFactory };
